export var initRemoveColumn = function (column) {
    column.getElement().querySelectorAll('[data-remove-column]').forEach(function (element) {
        element.addEventListener('click', function (e) {
            e.preventDefault();
            column.remove();
        });
    });
};
